// Single source of truth for the User Guide's sections.
//
// Consumed by both the guide landing page (GuideHome) and the sidebar sub-nav in
// App.jsx, so adding a section is a one-line change that shows up in both places.
// Set `available: false` for a section that is planned but not written yet — it
// renders as a muted "coming soon" card on the landing page and is skipped in the
// sidebar (a nav link to an empty page is worse than no link).
import { BellIcon, FolderOpenIcon } from '@heroicons/react/24/outline';

export const guideSections = [
  {
    to: '/guide/alerts',
    label: 'Alerts',
    icon: BellIcon,
    available: true,
    blurb:
      'Reading the alerts list, working the detail panel, running Session Trace and Token Use, ' +
      'managing suppressions, and the alert rule editor.',
  },
  {
    to: '/guide/cases',
    label: 'Running a Case Investigation',
    icon: FolderOpenIcon,
    available: false,
    blurb:
      'Building a case, retrieving logs, classifying IPs and sessions, working the timeline, ' +
      'and producing a report.',
  },
];

// Only the sections that actually have a page behind them.
export const availableGuideSections = guideSections.filter((s) => s.available);
